import React from 'react';
import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import TicketsOverviewTabs from '@/mytickets/TicketsOverviewTabs';

export function TicketsOverviewHeader({ active }) {
    return (
        <UserBoardHeader pageFixerClassName="tabs">
            <TicketsOverviewTabs active={active} />
        </UserBoardHeader>
    );
}
